/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketspayoutsdone2Inputs */

const en_ticketspayoutsdone2 = /** @type {(inputs: Ticketspayoutsdone2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Payouts are set up`)
};

const de_ticketspayoutsdone2 = /** @type {(inputs: Ticketspayoutsdone2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auszahlungen sind eingerichtet`)
};

/**
* | output |
* | --- |
* | "Payouts are set up" |
*
* @param {Ticketspayoutsdone2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketspayoutsdone2 = /** @type {((inputs?: Ticketspayoutsdone2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketspayoutsdone2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketspayoutsdone2(inputs)
	return de_ticketspayoutsdone2(inputs)
});
export { ticketspayoutsdone2 as "ticketsPayoutsDone" }